module.exports = __webpack_public_path__ + "static/media/pattern2.4bbd0114.jpg";